/* RESPONSIBLE TEAM: team-channels */
import SenderEmailAddressSummary, {
  type SenderEmailAddressSummaryWireFormat,
} from 'embercom/objects/inbox/sender-email-address-summary';

export enum senderSettingType {
  WorkspaceAddress = 0,
  InboundAddress = 1,
  TeammateAddress = 2,
}

export interface EmailSenderSettingsWireFormat {
  use_admin_app_email: boolean;
  admin_reply_default_address?: SenderEmailAddressSummaryWireFormat;
  sender_setting?: senderSettingType;
}

export default class EmailSenderSettings {
  readonly useAdminAppEmail: boolean;
  readonly adminReplyDefaultAddress?: SenderEmailAddressSummary;
  readonly senderSetting?: senderSettingType;

  constructor(
    useAdminAppEmail: boolean,
    adminReplyDefaultAddress?: SenderEmailAddressSummary,
    senderSettings?: senderSettingType,
  ) {
    this.useAdminAppEmail = useAdminAppEmail;
    this.adminReplyDefaultAddress = adminReplyDefaultAddress;
    this.senderSetting = senderSettings;
  }

  static deserialize(json: EmailSenderSettingsWireFormat): EmailSenderSettings {
    return new EmailSenderSettings(
      json.use_admin_app_email,
      json.admin_reply_default_address
        ? SenderEmailAddressSummary.deserialize(json.admin_reply_default_address)
        : undefined,
      json.sender_setting,
    );
  }

  static serialize(emailSenderSettings: EmailSenderSettings): EmailSenderSettingsWireFormat {
    return {
      use_admin_app_email: emailSenderSettings.useAdminAppEmail,
      admin_reply_default_address: emailSenderSettings.adminReplyDefaultAddress
        ? SenderEmailAddressSummary.serialize(emailSenderSettings.adminReplyDefaultAddress)
        : undefined,
      sender_setting: emailSenderSettings.senderSetting,
    };
  }
}
